import { Link } from "react-router-dom";
import { device } from "shared/constants/device";
import styled from "styled-components";
export const TextLinkPrimary = styled(Link)`
  color:var(--color-primary)
`


export const H1 = styled.h1`
  font-size:35px;
  line-height:40px;
  @media ${device.laptop} { 
    font-size:30px;
    line-height:35px;
  }
  @media ${device.tablet} { 
    font-size:25px;
    line-height:30px;
  }
`
export const H2 = styled.h2`
  font-size:30px;
  line-height:35px;
  @media ${device.laptop} { 
    font-size:25px;
    line-height:30px;
  }
  @media ${device.tablet} { 
    font-size:20px;
    line-height:25px;
  }
`
export const H3 = styled.h3`
  font-size:25px;
  line-height:30px;
  @media ${device.laptop} { 
    font-size:20px;
    line-height:25px;
  }
  @media ${device.tablet} { 
    font-size:15px;
    line-height:20px;
  }
`
export const H4 = styled.h4`
  font-size:20px;
  line-height:25px;
  @media ${device.laptop} { 
    font-size:15px;
    line-height:20px;
  }
  @media ${device.tablet} { 
    font-size:14px;
    line-height:16px;
  }
`

export const H5 = styled.h5`
  font-size:16px;
  line-height:20px;
  @media ${device.laptop} { 
    font-size:14px;
    line-height:16px;
  }
`
export const H6 = styled.h6`
  font-size:14px;
  line-height:16px;
  @media ${device.laptop} { 
    font-size:12px;
    line-height:14px;
  }
`